import {
  Component,
  OnInit,
  Input
} from '@angular/core';

import { AppState } from '../app.service';
import { Title } from './title';
import { XLargeDirective } from './x-large';
import { CurrencyPipe } from '@angular/common';

import { TweenMax, TimelineMax } from "gsap";
import * as $ from 'jquery/dist/jquery.min.js';

@Component({
  /**
   * The selector is what angular internally uses
   * for `document.querySelectorAll(selector)` in our index.html
   * where, in this case, selector is the string 'home'.
   */
  selector: 'home',  // <home></home>
  /**
   * We need to tell Angular's Dependency Injection which providers are in our app.
   */
  providers: [
    Title
  ],  /**
   * Our list of styles in our component. We may add more to compose many styles together.
   */
  styles: [ require('./home.component.css') ],
  /**
   * Every Angular template is first compiled by the browser before Angular runs it's compiler.
   */
  template: require('./home.component.html')
})
export class HomeComponent implements OnInit {
  /**
   * Set our default values
   */
  public localState = { value: '' };

  //the images of the website to be lazyLoaded

  main_background = "assets/img/debbie.jpg";
 
  offset = 250;

  rentals = [
    {
      location: "Upminster, Essex, UK",
      airport: "Damyns Hall",
      company: "Tiger Club",
      plane_type: "Druine Turbulent",
      cruise: 85,
      rate: 75,
      rate_type: "airvent",
      fuel_cost: 0,
      additional_costs_hour: 0,
      additional_costs_leg: 9,
      landing_fees: 0,
      membership_fees: 250,
      membership_term: "year",
      total: 0,
      distance: 0,
      hourly: 0,
      mile: 0,
      notes: "Need to have tailwheel experience / want to learn tailwheel"
    },
    {
      location: "Maidenhead, Berkshire",
      airport: "White Waltham",
      company: "West London AeroClub",
      plane_type: "PA28",
      cruise: 100,
      rate: 155,
      rate_type: "brakes",
      fuel_cost: 0,
      additional_costs_hour: 0,
      additional_costs_leg: 0,
      landing_fees: 0,
      membership_fees: 350,
      membership_term: "year",
      total: 0,
      distance: 0,
      hourly: 0,
      mile: 0,
      notes: "Rates 10h pre-paid. Need to have approval for every single field you decide to visit by an instructor, some instructors have a bit of a big head... One particular member of staff likes to rip you off every chance they get"
    },
    {
      location: "Thirsk, Yorkshire",
      airport: "Bagby",
      company: "Flying Fox Aviation",
      plane_type: "PA28",
      cruise: 90,
      rate: 40,
      rate_type: "tacho",
      fuel_cost: 40,
      additional_costs_hour: 0,
      additional_costs_leg: 0,
      landing_fees: 0,
      membership_fees: 0,
      membership_term: "year",
      total: 0,
      distance: 0,
      hourly: 0,
      mile: 0,
      notes: ""
    },
    {
      location: "Shropshire",
      airport: "Sleap",
      company: "Unknown",
      plane_type: "C152",
      cruise: 90,
      rate: 111,
      rate_type: "brakes",
      fuel_cost: 0,
      additional_costs_hour: 0,
      additional_costs_leg: 0,
      landing_fees: 0,
      membership_fees: 0,
      membership_term: "year",
      total: 0,
      distance: 0,
      hourly: 0,
      mile: 0,
      notes: "Ask Graham Nulty"
    },
    {
      location: "Shropshire",
      airport: "Sleap",
      company: "Unknown",
      plane_type: "C172",
      cruise: 100,
      rate: 148,
      rate_type: "brakes",
      fuel_cost: 0,
      additional_costs_hour: 0,
      additional_costs_leg: 0,
      landing_fees: 0,
      membership_fees: 0,
      membership_term: "year",
      total: 0,
      distance: 0,
      hourly: 0,
      mile: 0,
      notes: "Ask Graham Nulty"
    },
    {
      location: "Lee-on-Solent",
      airport: "Lee-on-Solent",
      company: "Unknown",
      plane_type: "PA28 Archer",
      cruise: 100,
      rate: 148,
      rate_type: "brakes",
      fuel_cost: 0,
      additional_costs_hour: 0,
      additional_costs_leg: 0,
      landing_fees: 0,
      membership_fees: 0,
      membership_term: "year",
      total: 0,
      distance: 0,
      hourly: 0,
      mile: 0,
      notes: "Ask Luke Clark"
    },
    {
      location: "Lee-on-Solent",
      airport: "Lee-on-Solent",
      company: "Unknown",
      plane_type: "PA28 Warrior",
      cruise: 100,
      rate: 130,
      rate_type: "brakes",
      fuel_cost: 0,
      additional_costs_hour: 0,
      additional_costs_leg: 0,
      landing_fees: 0,
      membership_fees: 0,
      membership_term: "year",
      total: 0,
      distance: 0,
      hourly: 0,
      mile: 0,
      notes: "Ask Luke Clark"
    },
    {
      location: "Stapleford",
      airport: "Stapleford",
      company: "FlySFC",
      plane_type: "C152",
      cruise: 90,
      rate: 130,
      rate_type: "brakes",
      fuel_cost: 0,
      additional_costs_hour: 0,
      additional_costs_leg: 0,
      landing_fees: 0,
      membership_fees: 0,
      membership_term: "year",
      total: 0,
      distance: 0,
      hourly: 0,
      mile: 0,
      notes: "Ask Jonathon Tully"
    },
    {
      location: "Tattenhill",
      airport: "Tattenhill",
      company: "unknown",
      plane_type: "C152",
      cruise: 90,
      rate: 130,
      rate_type: "brakes",
      fuel_cost: 0,
      additional_costs_hour: 0,
      additional_costs_leg: 0,
      landing_fees: 0,
      membership_fees: 0,
      membership_term: "year",
      total: 0,
      distance: 0,
      hourly: 0,
      mile: 0,
      notes: "Ask Adam Firth"
    },
    {
      location: "Tattenhill",
      airport: "Tattenhill",
      company: "unknown",
      plane_type: "PA28 Warrior",
      cruise: 100,
      rate: 150,
      rate_type: "brakes",
      fuel_cost: 0,
      additional_costs_hour: 0,
      additional_costs_leg: 0,
      landing_fees: 0,
      membership_fees: 0,
      membership_term: "year",
      total: 0,
      distance: 0,
      hourly: 0,
      mile: 0,
      notes: "Ask Adam Firth"
    },
    {
      location: "Blackbushe",
      airport: "Blackbushe",
      company: "Blackbushe Flying Group",
      plane_type: "C150",
      cruise: 90,
      rate: 95,
      rate_type: "brakes",
      fuel_cost: 0,
      additional_costs_hour: 0,
      additional_costs_leg: 0,
      landing_fees: 0,
      membership_fees: 55,
      membership_term: "month",
      total: 0,
      distance: 0,
      hourly: 0,
      mile: 0,
      notes: "Ask them"
    },
    {
      location: "Blackbushe",
      airport: "Blackbushe",
      company: "Blackbushe Flying Group",
      plane_type: "C150",
      cruise: 90,
      rate: 85,
      rate_type: "brakes",
      fuel_cost: 0,
      additional_costs_hour: 0,
      additional_costs_leg: 0,
      landing_fees: 0,
      membership_fees: 133,
      membership_term: "month",
      total: 0,
      distance: 0,
      hourly: 0,
      mile: 0,
      notes: "Ask them"
    },
    {
      location: "Biggin Hill",
      airport: "Biggin Hill Airport",
      company: "Alouette Flying Club",
      plane_type: "C172 or PA28",
      cruise: 100,
      rate: 165,
      rate_type: "tacho",
      fuel_cost: 0,
      additional_costs_hour: 0,
      additional_costs_leg: 0,
      landing_fees: 22,
      membership_fees: 250,
      membership_term: "year",
      total: 0,
      distance: 0,
      hourly: 0,
      mile: 0,
      notes: "Ask them"
    },
    {
      location: "Biggin Hill",
      airport: "Biggin Hill Airport",
      company: "Falcon Aviation",
      plane_type: "PA28R",
      cruise: 130,
      rate: 115,
      rate_type: "tacho",
      fuel_cost: 0,
      additional_costs_hour: 0,
      additional_costs_leg: 0,
      landing_fees: 22,
      membership_fees: 100,
      membership_term: "month",
      total: 0,
      distance: 0,
      hourly: 0,
      mile: 0,
      notes: "Ask them"
    },
    {
      location: "Fairoaks",
      airport: "Fairoaks Airport",
      company: "LTFC",
      plane_type: "PA28/C172",
      cruise: 100,
      rate: 150,
      rate_type: "brakes",
      fuel_cost: 0,
      additional_costs_hour: 0,
      additional_costs_leg: 0,
      landing_fees: 0,
      membership_fees: 0,
      membership_term: "month",
      total: 0,
      distance: 0,
      hourly: 0,
      mile: 0,
      notes: "Ask them"
    },
    {
      location: "Selby, North Yorkshire",
      airport: "Breighton",
      company: "Yorkshire Flying School",
      plane_type: "C150",
      cruise: 90,
      rate: 105,
      rate_type: "brakes",
      fuel_cost: 0,
      additional_costs_hour: 0,
      additional_costs_leg: 0,
      landing_fees: 0,
      membership_fees: 70,
      membership_term: "year",
      total: 0,
      distance: 0,
      hourly: 0,
      mile: 0,
      notes: "Ask them"
    },
    {
      location: "Nottinghamshire",
      airport: "Netherthorpe Airfield",
      company: "Phoenix Flying School",
      plane_type: "C150",
      cruise: 90,
      rate: 99,
      rate_type: "brakes",
      fuel_cost: 0,
      additional_costs_hour: 0,
      additional_costs_leg: 0,
      landing_fees: 0,
      membership_fees: 0,
      membership_term: "year",
      total: 0,
      distance: 0,
      hourly: 0,
      mile: 0,
      notes: "Ask them"
    },
    {
      location: "Exeter",
      airport: "Exeter Airport",
      company: "unknown",
      plane_type: "PA38",
      cruise: 90,
      rate: 90,
      rate_type: "brakes",
      fuel_cost: 0,
      additional_costs_hour: 0,
      additional_costs_leg: 0,
      landing_fees: 0,
      membership_fees: 0,
      membership_term: "year",
      total: 0,
      distance: 0,
      hourly: 0,
      mile: 0,
      notes: "Ask them"
    },
    {
      location: "Sherburn in Elmet, Leeds",
      airport: "Sherburn",
      company: "Sherburn Aero Club",
      plane_type: "AT3",
      cruise: 90,
      rate: 114,
      rate_type: "brakes",
      fuel_cost: 0,
      additional_costs_hour: 0,
      additional_costs_leg: 0,
      landing_fees: 10,
      membership_fees: 45,
      membership_term: "month",
      total: 0,
      distance: 0,
      hourly: 0,
      mile: 0,
      notes: "Ask them"
    }


  ];

  hours = 50;
  hours_per_leg = 2;
  hours_per_month = 25;
  landings = 5;
  away_landings = 200;

  /**
   * TypeScript public modifiers
   */
  constructor(
    public appState: AppState,
    public title: Title
  ) {}

  public ngOnInit() {
    // console.log('hello `Home` component');
    /**
     * this.title.getData().subscribe(data => this.data = data);
     */
    //  var scene = new this.appState.ScrollMagic.Scene({
    //   triggerElement: "#trigger",
    //   duration: 60
    // })
    //   .setTween(TweenMax.to(this.test.nativeElement, 0.5, { y: -40 }))
    //   .addTo(this.appState.controller);
     this.calculate();
  }

  public scrollTo(id){
     $('html, body').animate({
        scrollTop: $("#"+id).offset().top - 80
    }, 1000);
  }

  public calculate(){
    // console.log("value test", this.rentals);
    // console.log("length", this.rentals.length);
    for(var i=0;i<this.rentals.length;i++){
      // console.log("I", i);
      this.rentals[i].total = this.calculate_total(this.rentals[i]);
      this.rentals[i].distance = this.calculate_distance(this.rentals[i]);
      this.rentals[i].hourly = this.calculate_cost_per_hour(this.rentals[i]);
      this.rentals[i].mile = this.calculate_cost_per_mile(this.rentals[i]);
    }
  }

  public get_ratio(rental_type){
    var ratio = 1;
    switch(rental_type){
      case "brakes":
        ratio = 1;
      break;
      case "tacho":
        ratio = 0.8;
      break;
      case "airvent":
        ratio = 1;
      break;
      case "hobbs":
        ratio = 1;
      break;
    }
    return ratio;
  }

  public calculate_total(plane){
    // console.log("==============> ONE");
    var ratio = this.get_ratio(plane.rate_type);

    var per_hour = (plane.rate + plane.fuel_cost + plane.additional_costs_hour) * ratio;

    var total_hour = per_hour * this.hours;

    var equating = 0;
    if(plane.rate_type == "hobbs"){
      equating = (plane.rate * 0.1);
    }
    if(plane.rate_type == "airvent"){
      equating = (plane.rate * -0.3);
    }
    // console.log(plane.rate_type);
    // console.log("Equating", equating);


    var per_leg = ((this.hours) / this.hours_per_leg);
    // console.log("number of legs", per_leg);
    var leg_adjustments = per_leg * equating;
    // console.log("leg adjustment", leg_adjustments);

    var total_leg = (per_leg * plane.additional_costs_leg) + (leg_adjustments);
    // console.log("Total Leg", total_leg);
    var no_months = this.hours / this.hours_per_month;
    var membership_costs = 0;
    if(plane.membership_term == "year" && no_months > 12){
      membership_costs = Math.ceil(no_months / 12) * plane.membership_fees;
    }else if(plane.membership_term == "month"){
      // console.log("MONTH ", Math.ceil(no_months));
      // console.log("member", plane.membership_fees);
      membership_costs = Math.ceil(no_months) * plane.membership_fees;
    } else {
      membership_costs = plane.membership_fees;
    }
    // console.log("membership", membership_costs);
    // console.log("total_leg", total_leg);
    // console.log("total_hour", total_hour);

    var landings = this.landings * plane.landing_fees;
    var total = total_hour + total_leg + membership_costs + landings + this.away_landings;

    return total;
  }

  public calculate_distance(plane){
    return plane.cruise * this.hours;
  }

  public calculate_cost_per_hour(plane){
    
    return this.calculate_total(plane) / this.hours;
    
  }

  public calculate_cost_per_mile(plane){
    
    return this.calculate_total(plane) / this.calculate_distance(plane);

  }

  public submitState(value: string) {
    console.log('submitState', value);
    this.appState.set('value', value);
    this.localState.value = '';
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/home/home.component.ts